<template>
  <div class="news">
<!--
  <meta property="og:url"           content="http://www.your-domain.com/your-page.html" />
  <meta property="og:type"          content="website" />
  <meta property="og:title"         content="Your Website Title" />
  <meta property="og:description"   content="Your description" />
  <meta property="og:image"         content="http://www.your-domain.com/path/image.jpg" />
-->


    <a class="image-link u-opacity lightbox" :href="link"  v-if="link.toLowerCase().indexOf('http') > -1" target="_blank"><img :src="require('../assets/'+image)" /></a>
    <router-link class="image-link u-opacity lightbox" :to="link"  v-if="link.toLowerCase().indexOf('http') < 0"><img :src="require('../assets/'+image)" /></router-link>
    <div class="content">
        <a class="lightbox" :href="link" v-if="link.toLowerCase().indexOf('http') > -1" target="_blank"><h2 v-html="titolo"></h2></a>
        <router-link class="lightbox" :to="link" v-if="link.toLowerCase().indexOf('http') < 0"><h2 v-html="titolo"></h2></router-link>
        <p class="text"><slot name="descrizione"></slot></p>
    

    <a class="share" :href="'https://www.facebook.com/sharer.php?u='+link"  v-if="link.toLowerCase().indexOf('http') > -1 && link!='#!'" target="_blank"><img src="../assets/facebook_grey.svg" alt="Facebook icon"></a>
    <a class="share" :href="'https://www.facebook.com/sharer.php?u=http://www.dapstudio.com/eng/page/'+link.split('/')[3]+'.html'"  v-if="link.toLowerCase().indexOf('http') < 0 && link!='#!'" target="_blank"><img src="../assets/facebook_grey.svg" alt="Facebook icon"></a>
    <!--
    <a class="share" :href="'https://www.facebook.com/sharer.php?u=http://www.dapstudio.com/site'"  v-if="link=='#!'" target="_blank"><img src="../assets/facebook_grey.svg" alt="Facebook icon"></a>
    -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'news',
  props: {
    titolo: '',
    link: '',
    image: ''
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.news{
  padding:0 20px 20px 0;
}img{
  width: 100%;
  padding:0 2px;
}h2{
  text-transform:uppercase;
  font-size:1.4rem;
  padding:10px 0;
  margin:0;
  color: #222222;
  font-weight: 700;

}.content{
  padding:0 5px;
  /* min-height: 240px; */
}a.share{
  width:19px;
  display:block;
  margin:6px 0 14px 0;
}
</style>



// WEBPACK FOOTER //
// News.vue?309af72e